import React from "react";
import {
  WSAlert,
  WSAlertProps,
  WSList,
  WSListProps
} from "@wingspanhq/fe-component-library";

export type AlertProps = WSAlertProps & { children?: React.ReactNode };

export interface AlertsProps extends WSListProps {
  alerts: (AlertProps | undefined)[];
}

const alertPriorityOrder: WSAlertProps["theme"][] = [
  "error",
  "warning",
  "success",
  "info",
  "neutral"
];

export const Alerts: React.FC<AlertsProps> = ({ alerts, ...listProps }) => {
  const sortedAlerts = alerts.filter(Boolean).sort((a, b) => {
    const aIndex = alertPriorityOrder.indexOf(a?.theme || "neutral");
    const bIndex = alertPriorityOrder.indexOf(b?.theme || "neutral");
    return aIndex - bIndex;
  });

  if (!sortedAlerts.length) {
    return null;
  }

  return (
    <WSList gap="S" {...listProps}>
      {sortedAlerts.map((alert, index) => (
        <WSAlert key={`${alert?.title}-${index}`} {...alert} />
      ))}
    </WSList>
  );
};
